module.exports = __webpack_public_path__ + "img/MENU.a2a75d60.svg";